import * as React from "react";

function SvgEmarsys(props, ref) {
  return (
    <svg
      id="Emarsys_svg__Logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.85 36.85"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".Emarsys_svg__cls-1{fill:#0c2838}"}</style>
      </defs>
      <path fill="#40877e" d="M12.73 17.01v5.67L0 17.01v-5.67l12.73 5.67z" />
      <path fill="#32d17e" d="M25.47 5.67L0 17.01v-5.67L25.47 0v5.67z" />
      <path
        fill="#d9e506"
        d="M12.73 17.01v5.67l12.74-5.67v-5.67l-12.74 5.67z"
      />
      <path fill="#6984d1" d="M6.37 31.18v5.67l19.1-8.5v-5.67l-19.1 8.5z" />
    </svg>
  );
}

export default React.forwardRef(SvgEmarsys);
